<template>
<div v-if="!historyReadOnly" :class="{'mt-5': $uiHelpers.isMobileOrTablet, 'mt-4': !$uiHelpers.isMobileOrTablet}">
    <history-wrapper :title="$t('feeding')">
        <history-healthy-habits-item v-for="item in feedingData" :key="item.id" :id="item.id" :name="$i18nHelpers.normalize(item.name)" :frequencyId="item.frequencyId" :unit="item.unit" :createdHabitId="item.createdHabitId"></history-healthy-habits-item>
    </history-wrapper>
    <history-wrapper :title="$t('exercise')">
        <history-healthy-habits-item v-for="item in exerciseData" :key="item.id" :id="item.id" :name="$i18nHelpers.normalize(item.name)" :frequencyId="item.frequencyId" :unit="item.unit" :createdHabitId="item.createdHabitId"></history-healthy-habits-item>
    </history-wrapper>
    <history-wrapper :title="$t('habits')">
        <history-healthy-habits-item v-for="item in habitsData" :key="item.id" :id="item.id" :name="$i18nHelpers.normalize(item.name)" :frequencyId="item.frequencyId" :unit="item.unit" :createdHabitId="item.createdHabitId"></history-healthy-habits-item>
    </history-wrapper>
</div>
<div v-else v-html="$t('canNotAccessReadOnly')"></div>
</template>

<script>
import HistoryHealthyHabitsItem from '@/components/shared/HistoryHealthyHabitsItem'
import HistoryWrapper from '@/components/views/clinicHistory/ClinicHistorySectionWrapper'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import { FEEDING_HABIT_GROUP, EXERCISE_HABIT_GROUP, HABITS_HABIT_GROUP } from '@/constants/clinicHistory'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    components: {
        HistoryWrapper,
        HistoryHealthyHabitsItem
    },
    props: {
    },
    created () {
        if (this.historyReadOnly) return
        ClinicHistoryRepository().getHealthyHabits().then(response => {
                let data = response.data.data
                if (data) {
                    this.feedingData = data.habitsTypes.filter(item => item.groupHabitId === FEEDING_HABIT_GROUP)
                    this.exerciseData = data.habitsTypes.filter(item => item.groupHabitId === EXERCISE_HABIT_GROUP)
                    this.habitsData = data.habitsTypes.filter(item => item.groupHabitId === HABITS_HABIT_GROUP)
                }
            })
    },
    mixins: [clinicHistoryMixin],
    data () {
        return {
            feedingData: [],
            exerciseData: [],
            habitsData: []
        }
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryHealthyHabitsSection.vue